import React from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import { theme } from "../constants/theme";
import CssBaseline from "@material-ui/core/CssBaseline";
import { CustomTabs, CustomTab, TabPanel } from "../components-molecules";
import CollectionList from "./CollectionList";
import PromotionalBanners from "./PromotionalBanners";
const Collections = (props: any) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <CssBaseline />
        <Typography variant="h5" component="span" color="textPrimary">
          Collections
        </Typography>
        <Container className={classes.tabContainer}>
          <CustomTabs value={value} onChange={handleChange}>
            <CustomTab label="Collections" textColor="primary" />
            <CustomTab label="Promotional Banners" />
          </CustomTabs>
        </Container>
        <TabPanel value={value} index={0}>
          <CollectionList />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <PromotionalBanners />
        </TabPanel>
      </Container>
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    flexGrow: 1,
    maxWidth: "840px",
  },
  tabContainer: {
    backgroundColor: theme.palette.background.paper,
    paddingBottom: "8px",
  },
});

export default Collections;
